import { ILocaleStrings } from './index'

export default {
    'common.logout': 'Logout',
    'common.mv': 'Milli-volt',
    'common.v': 'V',
    'common.celsius': '°C',
    'common.bar': 'Bar',
    'common.rps': 'Rps',
    'common.saved': 'Saved',
    'common.success': '{0} successfully',
    'common.on_cooldown': '{0} is on cooldown',
    'common.activate': 'Start {0}',
    'common.finished': 'Finished',
    'common.save': 'Save',
    'common.unsaved_changes': 'There are unsaved changes',
    'common.delete': 'Delete',
    'common.deleted': 'Deleted',
    'common.old_software_message': 'Outdated version, consider upgrading to {0}',
    'common.activated': 'Activated {0} ago',
    'common.deactivated': 'Deactivated {0} ago',
    'common.status': 'Status',
    'common.previous': 'Previous',
    'common.next': 'Next',
    'common.first_page': 'First page',
    'common.last_page': 'Last page',
    'common.thermostat': 'Thermostat',
    'common.active_time': 'Active time',
    'common.inactive_time': 'Inactive time',
    'common.disconnected': 'Disconnected',
    'common.cancel': 'Cancel',
    'common.edit': 'Edit',
    'common.ambient_temp': "Ambient Temp'",
    'common.included': 'Included',
    'common.excluded': 'Excluded',
    'common.scan': 'Scan',
    'common.loading': 'Loading',
    'common.counter': 'Counter',
    'common.show_password': 'Show password',
    'common.hide_password': 'Hide password',

    'pagelabels.login': 'Login',
    'pagelabels.dashboard_internal': 'Dashboard Internal',
    'pagelabels.dashboard_external': 'Dashboard External',
    'pagelabels.client': 'Client',
    'pagelabels.datacenter': 'Data Center',
    'pagelabels.machine': 'Machine',
    'pagelabels.software-manager': 'OTA Files',
    'pagelabels.mobile_apps': 'Mobile Apps',
    'pagelabels.usb_flash_artifacts': 'USB Flash Artifacts',
    'pagelabels.usb_flasher_web': 'USB Flasher (Web)',
    'pagelabels.usb_flash_erase_web': 'USB Flash Erase (Web)',
    'pagelabels.usb_serial_monitor_web': 'USB Serial Monitor (Web)',
    'pagelabels.quicksupport': 'Quick Support',
    'pagelabels.admin': 'Admin',
    'pagelabels.software-version': 'Software Version',
    'pagelabels.new-software-version': 'New Software Version',
    'pagelabels.multiclient': 'Multi Client',
    'pagesections.dashboards': 'Dashboards',
    'pagesections.artifacts': 'Artifacts',
    'pagesections.administration': 'Administration',
    'pagesections.user': 'User',

    'time.days': 'days',
    'time.hours': 'hours',
    'time.minutes': 'minutes',
    'time.seconds': 'seconds',
    'time.d': 'd',
    'time.h': 'h',
    'time.m': 'm',
    'time.s': 's',
    'time.less_than_a_second': 'Less than a second',
    'time.half_second': 'Half second',

    'login.signin_message': 'Sign in to your account',
    'login.username': 'Username',
    'login.password': 'Password',
    'login.remember_me': 'Remember me',
    'login.button': 'Sign in',
    'login.error.invalid_username': 'Invalid username',
    'login.error.invalid_password': 'Invalid password',
    'login.error.wrong_credentials': 'Wrong username/user number or password',
    'login.error.user_disabled': 'User is disabled',
    'login.error.locked': 'Too many failed login attempts. Please try again shortly.',
    'login.error.locked_seconds': 'Too many failed login attempts. Try again in {0} second(s).',
    'login.error.rate_limited': 'Rate limit exceeded. Please try again shortly.',
    'login.error.rate_limited_seconds': 'Rate limit exceeded. Retry in {0} second(s).',
    'login.error.access_denied': 'Access denied',
    'login.error.unexpected': 'Login failed',

    'dashboard.connected': 'Connected',
    'dashboard.client_id': 'Client ID',
    'dashboard.mac': 'MAC Address',
    'dashboard.ip': 'IP Address',
    'dashboard.model': 'Model',
    'dashboard.device_name': 'Device Name',
    'dashboard.phone_model': 'Device Model',
    'dashboard.system_name': 'System Name',
    'dashboard.system_version': 'System Version',
    'dashboard.no_clients': 'There are no connected clients',
    'dashboard.confirm_client_click': 'Select an action',
    'dashboard.enter_client': 'Connect to client',
    'dashboard.multiple_clients': 'View multiple clients',
    'dashboard.selected_clients': 'Selected clients',
    'dashboard.view_clients': 'View clients',
    'push.title': 'Push Notifications',
    'push.not_supported': 'Push notifications are not supported in this browser.',
    'push.subscribe': 'Subscribe',
    'push.unsubscribe': 'Unsubscribe',
    'push.test': 'Test Push',
    'push.subscribed': 'Push subscription enabled',
    'push.unsubscribed': 'Push subscription disabled',
    'push.subscribe_failed': 'Failed to subscribe to push notifications',
    'push.unsubscribe_failed': 'Failed to unsubscribe from push notifications',
    'push.test_sent': 'Test push sent',
    'push.test_failed': 'Failed to send test push',
    'push.subscribed_status': 'You are subscribed for notifications.',
    'push.unsubscribed_status': 'You are currently unsubscribed.',
    'push.create_rule': 'Create Notification Rule',
    'push.metric': 'Metric',
    'push.threshold_minutes': 'Threshold (minutes)',
    'push.cooldown_minutes': 'Cooldown (minutes)',
    'push.custom_label': 'Custom label (optional)',
    'push.add_rule': 'Add Rule',
    'push.no_rules': 'No rules defined for this machine.',
    'push.rule_created': 'Notification rule created',
    'push.rule_create_failed': 'Failed to create notification rule',
    'push.invalid_threshold': 'Threshold and cooldown must be positive values',
    'push.disable_rule': 'Disable',
    'push.enable_rule': 'Enable',
    'push.delete_confirm': 'Delete this notification rule?',
    'push.rule_line': '{0} over {1} minutes (cooldown {2} min)',
    'push.metric.cooling_unit_active_time': 'Cooling Unit Active Time',
    'push.metric.cooling_unit_inactive_time': 'Cooling Unit Inactive Time',
    'push.metric.pump_active_time': 'Pump Active Time',
    'push.metric.pump_inactive_time': 'Pump Inactive Time',
    'push.metric.boiler_active_time': 'Boiler Active Time',
    'push.metric.boiler_inactive_time': 'Boiler Inactive Time',
    'push.metric.fan_active_time': 'Fan Active Time',
    'push.metric.fan_inactive_time': 'Fan Inactive Time',
    'push.metric.circulation_pump_active_time': 'Circulation Pump Active Time',
    'push.metric.circulation_pump_inactive_time': 'Circulation Pump Inactive Time',

    'admin.server_controls': 'Server Controls',
    'admin.restart_hint': 'Use this action to restart the Control Center server process.',
    'admin.restart_server': 'Restart Server',
    'admin.restarting': 'Restarting...',
    'admin.restart_confirm': 'Restart the server now?',
    'admin.restart_sent': 'Restart command sent. Waiting for server to come back online.',
    'admin.restart_failed': 'Failed to restart server',
    'admin.clear_security_counters': 'Reset Security Counters',
    'admin.clearing_security_counters': 'Resetting counters...',
    'admin.clear_security_counters_confirm': 'Reset security counters now (login lockouts and rate limits)?',
    'admin.clear_security_counters_done': 'Security counters reset (auth: {0}, rate-limit: {1})',
    'admin.clear_security_counters_failed': 'Failed to reset security counters',
    'admin.license_center': 'License Center',
    'admin.license_center_hint': 'Manage licenses for all connected LTSP101 devices in one place.',
    'admin.license_load_error': 'Failed to load license data',
    'admin.license_no_ltsp': 'No connected LTSP101 devices found.',
    'admin.license_open_device': 'Open Device License Tab',
    'admin.license_manager': 'License Key Manager',
    'admin.license_manager_hint': 'Create, edit, revoke and delete LTSP101 license keys.',
    'admin.license_create': 'Create License',
    'admin.license_created': 'License created',
    'admin.license_create_error': 'Failed to create license',
    'admin.license_updated': 'License updated',
    'admin.license_update_error': 'Failed to update license',
    'admin.license_deleted': 'License deleted',
    'admin.license_delete_error': 'Failed to delete license',
    'admin.license_delete_confirm': 'Delete this license key?',
    'admin.license_key_optional': 'License key (optional, auto-generated if empty)',
    'admin.license_key_label': 'License Key',
    'admin.license_plan_label': 'Plan',
    'admin.license_plan_monthly': 'Monthly',
    'admin.license_plan_yearly': 'Yearly',
    'admin.license_plan_custom': 'Custom',
    'admin.license_duration_label': 'Duration (days)',
    'admin.license_notes_label': 'Notes',
    'admin.license_duration_help': 'Duration is in days. 30 means 30 days from activation.',
    'admin.license_duration_days': 'Duration days',
    'admin.license_notes': 'Notes',
    'admin.license_device_id': 'Assigned Device ID (optional)',
    'admin.license_revoke': 'Revoke',
    'admin.license_unrevoke': 'Unrevoke',
    'admin.license_no_records': 'No licenses found',
    'admin.usb_flasher_code_label': 'Public USB flasher code',
    'admin.usb_flasher_code_refresh_in': 'Refresh in',
    'admin.usb_flasher_code_error': 'Failed to load USB flasher access code',

    'client.disconnect_message': 'Client {0} disconnected',
    'client.system_info': 'System Info',
    'client.logs': 'Logs',
    'client.settings': 'Settings',
    'client.wifi_config': 'Wi-Fi',
    'client.datetime': 'Change Date and Time',
    'client.customer_data': 'Customer Data',
    'client.channels': 'Channels',
    'client.system_actions': 'System Actions',
    'client.monitoring': 'Monitoring',
    'client.ota': 'Software Update',
    'client.flash_device': 'Initial Flash',

    'monitoring.title': 'Monitoring',
    'monitoring.description': 'Enable server-side monitoring to evaluate push notification rules continuously.',
    'monitoring.enabled': 'Monitoring enabled',
    'monitoring.disabled': 'Monitoring disabled',
    'monitoring.enable': 'Enable monitoring',
    'monitoring.disable': 'Disable monitoring',
    'monitoring.required_for_push': 'Monitoring must be enabled for push rules to trigger.',
    'monitoring.live_title': 'Live Monitoring',
    'monitoring.updated_at': 'Updated',

    'channels.title': 'Channel Management',
    'channels.loading': 'Loading channels...',
    'channels.all_control': 'All Channels Control',
    'channels.channel': 'Channel',
    'channels.active': 'Active',
    'channels.inactive': 'Inactive',
    'channels.mode': 'Mode',
    'channels.mode_solenoid': 'Solenoid',
    'channels.mode_relay': 'Relay',
    'channels.pwm': 'PWM',
    'channels.syrup_id': 'Syrup ID',
    'channels.syrup_none': 'None',
    'channels.status': 'Status',
    'channels.calibrating': 'Calibrating...',
    'channels.ready': 'Ready',
    'channels.calibration': 'Calibration',
    'channels.not_calibrated': 'Not calibrated',
    'channels.turn_on': 'Turn On',
    'channels.turn_off': 'Turn Off',
    'channels.edit_channel': 'Edit Channel',
    'channels.save': 'Save',
    'channels.cancel': 'Cancel',
    'channels.all_control_title': 'Control All Channels',
    'channels.all_control_desc': 'Choose an action to apply to all active channels:',
    'channels.all_on': 'Turn All On',
    'channels.all_off': 'Turn All Off',
    'channels.emergency_stop': 'Emergency Stop',
    'channels.update_success': 'Channel {0} updated successfully',
    'channels.update_failed': 'Failed to update channel',
    'channels.control_success_on': 'Channel {0} turned on',
    'channels.control_success_off': 'Channel {0} turned off',
    'channels.control_failed': 'Failed to control channel',
    'channels.all_control_success_on': 'All channels turned on',
    'channels.all_control_success_off': 'All channels turned off',
    'channels.all_control_success_stop': 'Emergency stop executed',
    'channels.all_control_failed': 'Failed to control channels',
    'channels.load_failed': 'Failed to load channels',
    'channels.btn_edit': 'Edit',
    'channels.btn_calibrate': 'Calibrate',
    'channels.btn_manual': 'Manual',
    'channels.manual_title': 'Manual Control',
    'channels.manual_desc': 'Control this channel manually:',
    'channels.calibrate_confirm': 'Are you sure you want to calibrate channel {0}?',
    'channels.calibrate_success': 'Channel {0} calibration started',
    'channels.calibrate_failed': 'Failed to calibrate channel',
    'channels.syrup_name': 'Syrup Name',
    'channels.used_in_drinks': 'Used in Drinks',
    'channels.calibration_duration': 'Calibration Duration',
    'channels.calib_start_msg': 'Press Start to begin calibration, or use Manual Entry to enter a calibration time.',
    'channels.calib_running_msg': 'Calibration in progress... Please wait.',
    'channels.calib_complete_msg': 'Calibration complete!',
    'channels.calib_result': 'Duration: {0}s',
    'channels.calib_save': 'Save',
    'channels.calib_retry': 'Retry',
    'channels.calib_start': 'Start',
    'channels.calib_cancel_btn': 'Cancel',
    'channels.calib_close': 'Close',
    'channels.calib_manual': 'Manual Entry',
    'channels.calib_manual_placeholder': 'Time (ms)',
    'channels.calib_confirm': 'Confirm',
    'channels.calib_canceled': 'Calibration canceled',

    'drinks.title': 'Drinks',
    'drinks.add': 'Add Drink',
    'drinks.edit': 'Edit',
    'drinks.base_drink': 'Base Drink',
    'drinks.delete_confirm': 'Are you sure you want to delete this drink?',
    'drinks.empty': 'No drinks found. Create your first drink!',
    'drinks.load_error': 'Failed to load drinks',
    'drinks.create_success': 'Drink created successfully',
    'drinks.create_error': 'Failed to create drink',
    'drinks.update_success': 'Drink updated successfully',
    'drinks.update_error': 'Failed to update drink',
    'drinks.delete_success': 'Drink deleted successfully',
    'drinks.delete_error': 'Failed to delete drink',
    'drinks.save_error': 'Failed to save drink',
    'drinks.required_fields': 'Please fill in all required fields',
    'drinks.title_en': 'Title (English)',
    'drinks.title_he': 'Title (Hebrew)',
    'drinks.description_en': 'Description (English)',
    'drinks.description_he': 'Description (Hebrew)',
    'drinks.base_channel': 'Base Channel',
    'drinks.flavour_channel': 'Flavour Channel',
    'drinks.no_flavour': 'None',
    'drinks.brix_ratio': 'Brix Ratio',
    'drinks.brix_ratio_a': 'Brix Ratio A',
    'drinks.brix_ratio_b': 'Brix Ratio B',
    'drinks.solenoid_only': 'Solenoid channels only',

    'pouring.title': 'Pouring',
    'pouring.select_drink': 'Select Drink',
    'pouring.select_drink_first': 'Please select a drink first',
    'pouring.pouring_mode': 'Pouring Mode',
    'pouring.manual': 'Manual',
    'pouring.cup': 'Cup',
    'pouring.bottle': 'Container',
    'pouring.sweetness': 'Sweetness Level',
    'pouring.light': 'Light',
    'pouring.regular': 'Regular',
    'pouring.sweet': 'Sweet',
    'pouring.extra_sweet': 'Extra Sweet',
    'pouring.status': 'Pouring Status',
    'pouring.volume': 'Volume',
    'pouring.progress': 'Progress',
    'pouring.start': 'Start Pouring',
    'pouring.stop': 'Stop Pouring',
    'pouring.emergency_stop': 'Emergency Stop',
    'pouring.started': 'Pouring started successfully',
    'pouring.stopped': 'Pouring stopped',
    'pouring.emergency_stopped': 'Emergency stop executed',
    'pouring.start_error': 'Failed to start pouring',
    'pouring.stop_error': 'Failed to stop pouring',
    'pouring.emergency_stop_error': 'Failed to execute emergency stop',
    'pouring.completion_window': 'Completion window',
    'pouring.completed_waiting': 'Pour completed. Session stays active for top-off.',
    'pouring.completion_seconds_left': 'Closing in {0}s',
    'pouring.manual_top_off': 'Manual Top-Off',
    'pouring.manual_top_off_hint': 'Use manual top-off before session closes.',
    'pouring.hold_to_top_off': 'Hold to top-off',
    'pouring.tap_to_toggle_top_off': 'Tap to start/stop top-off',
    'pouring.top_off_active': 'Top-off active',
    'pouring.top_off_stopped': 'Top-off stopped',
    'drinks.relay_only': 'Relay channels only',
    'drinks.optional': 'Optional',

    'syrups.title': 'Syrups',
    'syrups.add': 'Add Syrup',
    'syrups.edit': 'Edit Syrup',
    'syrups.delete_confirm': 'Are you sure you want to delete this syrup?',
    'syrups.empty': 'No syrups found. Create your first syrup!',
    'syrups.load_error': 'Failed to load syrups',
    'syrups.create_success': 'Syrup created successfully',
    'syrups.create_error': 'Failed to create syrup',
    'syrups.update_success': 'Syrup updated successfully',
    'syrups.update_error': 'Failed to update syrup',
    'syrups.delete_success': 'Syrup deleted successfully',
    'syrups.delete_error': 'Failed to delete syrup',
    'syrups.save_error': 'Failed to save syrup',
    'syrups.required_fields': 'Please fill in all required fields',
    'syrups.name_en': 'Name (English)',
    'syrups.name_he': 'Name (Hebrew)',
    'syrups.description_en': 'Description (English)',
    'syrups.description_he': 'Description (Hebrew)',
    'syrups.package_size': 'Package Size (L)',
    'syrup_usage.title': 'Syrup Usage',
    'syrup_usage.load_error': 'Failed to load syrup usage',
    'syrup_usage.empty': 'No linked syrups found',
    'syrup_usage.channel': 'Channel',
    'syrup_usage.used_ml': 'Used (ml)',
    'syrup_usage.remaining_ml': 'Remaining (ml)',
    'syrup_usage.package_l': 'Package (L)',
    'syrup_usage.remaining': 'Remaining',
    'syrup_usage.replace': 'Replace Syrup',
    'syrup_usage.replace_success': 'Syrup usage reset',
    'syrup_usage.replace_error': 'Failed to replace syrup',
    'pump_usage.title': 'Pump Usage',
    'pump_usage.load_error': 'Failed to load pump usage',
    'pump_usage.empty': 'No pump usage entries found',
    'pump_usage.mode': 'Mode',
    'pump_usage.active': 'Active',
    'pump_usage.is_on': 'Is On',
    'pump_usage.runtime': 'Runtime',
    'pump_usage.replace': 'Replace Pump',
    'pump_usage.replace_success': 'Pump runtime reset',
    'pump_usage.replace_error': 'Failed to replace pump',

    'ltsp101_catalog.title': 'LTSP101 Catalog',
    'ltsp101_catalog.syrups_tab': 'Syrups',
    'ltsp101_catalog.drinks_tab': 'Drinks',
    'ltsp101_catalog.images_tab': 'Images',
    'ltsp101_catalog.search': 'Search catalog...',
    'ltsp101_catalog.add_syrup': 'Add Syrup',
    'ltsp101_catalog.edit_syrup': 'Edit Syrup',
    'ltsp101_catalog.add_drink': 'Add Drink',
    'ltsp101_catalog.edit_drink': 'Edit Drink',
    'ltsp101_catalog.add_image': 'Add Image',
    'ltsp101_catalog.edit_image': 'Edit Image',
    'ltsp101_catalog.syrups_empty': 'No syrups in the catalog yet.',
    'ltsp101_catalog.drinks_empty': 'No drinks in the catalog yet.',
    'ltsp101_catalog.images_empty': 'No images in the catalog yet.',
    'ltsp101_catalog.load_error': 'Failed to load catalog',
    'ltsp101_catalog.save_error': 'Failed to save catalog item',
    'ltsp101_catalog.delete_error': 'Failed to delete catalog item',
    'ltsp101_catalog.required_fields': 'Please fill in all required fields',
    'ltsp101_catalog.syrup_create_success': 'Syrup added to catalog',
    'ltsp101_catalog.syrup_update_success': 'Syrup updated',
    'ltsp101_catalog.syrup_delete_success': 'Syrup removed',
    'ltsp101_catalog.drink_create_success': 'Drink added to catalog',
    'ltsp101_catalog.drink_update_success': 'Drink updated',
    'ltsp101_catalog.drink_delete_success': 'Drink removed',
    'ltsp101_catalog.image_create_success': 'Image added to catalog',
    'ltsp101_catalog.image_update_success': 'Image updated',
    'ltsp101_catalog.image_delete_success': 'Image removed',
    'ltsp101_catalog.syrup_delete_confirm': 'Are you sure you want to delete this syrup?',
    'ltsp101_catalog.drink_delete_confirm': 'Are you sure you want to delete this drink?',
    'ltsp101_catalog.image_delete_confirm': 'Are you sure you want to delete this image?',
    'ltsp101_catalog.name_en': 'Name (English)',
    'ltsp101_catalog.name_he': 'Name (Hebrew)',
    'ltsp101_catalog.description_en': 'Description (English)',
    'ltsp101_catalog.description_he': 'Description (Hebrew)',
    'ltsp101_catalog.title_en': 'Title (English)',
    'ltsp101_catalog.title_he': 'Title (Hebrew)',
    'ltsp101_catalog.package_size': 'Package Size',
    'ltsp101_catalog.image': 'Catalog Image',
    'ltsp101_catalog.image_drop': 'Drop an image here or click to upload',
    'ltsp101_catalog.no_image': 'No image',
    'ltsp101_catalog.image_title': 'Image Title',
    'ltsp101_catalog.image_notes': 'Image Notes',
    'ltsp101_catalog.image_title_en': 'Image Title (English)',
    'ltsp101_catalog.image_title_he': 'Image Title (Hebrew)',
    'ltsp101_catalog.image_notes_en': 'Image Notes (English)',
    'ltsp101_catalog.image_notes_he': 'Image Notes (Hebrew)',
    'ltsp101_catalog.image_title_hint': 'Titles are set per file below (defaults to the file name).',
    'ltsp101_catalog.image_notes_hint': 'Notes are set per file below.',
    'ltsp101_catalog.image_drop_multiple': 'Drop images here or click to upload (multiple supported)',
    'ltsp101_catalog.base_channel': 'Base Channel',
    'ltsp101_catalog.flavour_channel': 'Flavour Channel',
    'ltsp101_catalog.no_flavour': 'None',
    'ltsp101_catalog.no_flavour_hint': 'Use 255 for no flavour channel',
    'ltsp101_catalog.brix_ratio': 'Brix Ratio',
    'ltsp101_catalog.brix_ratio_a': 'Brix Ratio A',
    'ltsp101_catalog.brix_ratio_b': 'Brix Ratio B',
    'ltsp101_catalog.api_docs_show': 'Show API docs',
    'ltsp101_catalog.api_docs_hide': 'Hide API docs',
    'ltsp101_catalog.api_docs_title': 'Embedded Catalog API',
    'ltsp101_catalog.api_docs_intro': 'Use this read-only API for embedded devices to fetch catalog data.',
    'ltsp101_catalog.api_docs_auth_title': 'Authentication',
    'ltsp101_catalog.api_docs_auth_body': 'Provide the catalog API key via the X-Api-Key header or apiKey query param.',
    'ltsp101_catalog.api_docs_endpoints_title': 'Endpoints',
    'ltsp101_catalog.api_docs_endpoint_all': 'GET (all catalog data):',
    'ltsp101_catalog.api_docs_endpoint_syrups': 'GET (syrups):',
    'ltsp101_catalog.api_docs_endpoint_drinks': 'GET (drinks):',
    'ltsp101_catalog.api_docs_endpoint_images': 'GET (images):',
    'ltsp101_catalog.api_docs_endpoint_names': 'GET (names):',
    'ltsp101_catalog.api_docs_endpoint_image_data': 'GET (image data):',
    'ltsp101_catalog.api_docs_example_title': 'Example request',
    'ltsp101_catalog.api_docs_response_title': 'Example response',
    'ltsp101_catalog.loading': 'Loading catalog...',
    'ltsp101_catalog.catalog': 'Catalog',
    'ltsp101_catalog.include_downloaded': 'Include downloaded',
    'ltsp101_catalog.refresh': 'Refresh',
    'ltsp101_catalog.total': 'Total',
    'ltsp101_catalog.used': 'Used',
    'ltsp101_catalog.free': 'Free',
    'ltsp101_catalog.remote_images': 'Remote images',
    'ltsp101_catalog.local_images': 'Local images',
    'ltsp101_catalog.download': 'Download',
    'ltsp101_catalog.delete': 'Delete',
    'ltsp101_catalog.no_remote_images': 'No remote images',
    'ltsp101_catalog.no_local_images': 'No local images',
    'ltsp101_catalog.image_download_success': 'Image downloaded',
    'ltsp101_catalog.image_download_error': 'Download failed',
    'ltsp101_catalog.image_delete_error': 'Delete failed',

    'system.title': 'System',
    'system.info_section': 'System Information',
    'system.status_section': 'System Status',
    'system.settings_section': 'Settings',
    'system.app_version': 'App Version',
    'system.idf_version': 'IDF Version',
    'system.part_name': 'Part Name',
    'system.compile_date': 'Compile Date',
    'system.compile_time': 'Compile Time',
    'system.cores': 'CPU Cores',
    'system.revision': 'Chip Revision',
    'system.flash_size': 'Flash Size',
    'system.wifi_mac': 'WiFi MAC',
    'system.bt_mac': 'Bluetooth MAC',
    'system.uptime': 'Uptime',
    'system.free_heap': 'Free Heap',
    'system.rtc_time': 'RTC Time',
    'system.rtc_date': 'RTC Date',
    'system.timezone': 'Timezone',
    'system.brightness': 'Brightness',
    'system.brightness_adjust': 'Adjust Brightness',
    'system.language': 'Language',
    'system.language_select': 'Select Language',
    'system.time_date': 'Time & Date',
    'system.set_time': 'Set Time',
    'system.sync_time': 'Sync via NTP',
    'system.set_timezone': 'Set Timezone',
    'system.restart': 'Restart System',
    'system.restart_confirm': 'Are you sure you want to restart the system?',
    'system.restart_success': 'System restarting...',
    'system.restart_error': 'Failed to restart system',
    'system.lock_now': 'Lock Now',
    'system.lock_now_success': 'System lock requested',
    'system.lock_now_error': 'Failed to lock system',
    'system.admin_auth_title': 'Admin Gateway Auth',
    'system.admin_auth_send': 'Send Admin Key',
    'system.admin_auth_key_label': 'Admin key',
    'system.admin_auth_key_required': 'Admin key is required',
    'system.admin_auth_key_invalid': 'Admin key must be exactly 32 characters',
    'system.admin_auth_success': 'Admin key accepted',
    'system.admin_auth_error': 'Admin key request failed',
    'system.admin_relock_send': 'Relock Admin',
    'system.admin_relock_success': 'Admin session relocked',
    'system.admin_relock_error': 'Admin relock request failed',
    'system.user_security': 'User Security',
    'system.lock_on_startup': 'Lock on startup',
    'system.user_pin_placeholder': 'New user PIN (6 digits, optional)',
    'system.user_pin_invalid': 'PIN must be exactly 6 digits',
    'system.user_security_save': 'Save Security',
    'system.user_security_saved': 'User security saved',
    'system.user_security_save_error': 'Failed to save user security',
    'system.export_settings': 'Export Settings',
    'system.export_name_prompt': 'Choose a unique name for this settings export',
    'system.export_name_label': 'Profile name',
    'system.export_name_required': 'Please enter a profile name',
    'system.export_saved_success': 'Settings exported and saved as "{0}"',
    'system.import_settings': 'Import Settings',
    'system.import_saved_settings': 'Import Saved',
    'system.saved_profiles_empty': 'No saved settings profiles found',
    'system.export_success': 'Settings exported successfully',
    'system.export_error': 'Failed to export settings',
    'system.import_success': 'Settings imported successfully',
    'system.import_error': 'Failed to import settings',
    'system.import_confirm': 'Are you sure you want to import settings? This will overwrite current settings.',
    'system.brightness_updated': 'Brightness updated',
    'system.brightness_error': 'Failed to update brightness',
    'system.time_updated': 'Time updated successfully',
    'system.time_error': 'Failed to update time',
    'system.time_syncing': 'Syncing time...',
    'system.time_synced': 'Time synced successfully',
    'system.time_sync_error': 'Failed to sync time',
    'system.timezone_updated': 'Timezone updated',
    'system.timezone_error': 'Failed to update timezone',
    'system.language_updated': 'Language updated',
    'system.language_error': 'Failed to update language',
    'system.select_timezone': 'Select Timezone',
    'system.year': 'Year',
    'system.month': 'Month',
    'system.day': 'Day',
    'system.hour': 'Hour',
    'system.minute': 'Minute',
    'system.use_pc_time': 'Use PC Time',

    'general_settings.title': 'General Settings',
    'general_settings.test_tube_volume': 'Test Tube Volume',
    'general_settings.test_tube_volume_desc': 'Volume of test tube used for calibration',
    'general_settings.rinse_duration': 'Additional Pouring Time',
    'general_settings.rinse_duration_desc': 'Applied before and after flavour pouring (base-only window)',
    'general_settings.cup_volume': 'Cup Volume',
    'general_settings.cup_volume_desc': 'Default cup volume for drinks',
    'general_settings.bottle_volume': 'Container Volume',
    'general_settings.bottle_volume_desc': 'Default container volume for drinks',
    'general_settings.edit': 'Edit',
    'general_settings.measure': 'Measure',
    'general_settings.save': 'Save',
    'general_settings.cancel': 'Cancel',
    'general_settings.ml': 'ml',
    'general_settings.ms': 'ms',
    'general_settings.minutes': 'minutes',
    'general_settings.seconds': 'seconds',
    'general_settings.current_value': 'Current Value',
    'general_settings.new_value': 'New Value',
    'general_settings.value_updated': 'Value updated successfully',
    'general_settings.update_error': 'Failed to update value',
    'general_settings.invalid_range': 'Value out of valid range',
    'general_settings.test_tube_range': 'Test tube volume must be between 50-1000ml',
    'general_settings.rinse_range': 'Allowed values: 0, 0.5s, 1s, 1.5s, 2s',
    'general_settings.cup_range': 'Cup volume must be between 50-2000ml',
    'general_settings.bottle_range': 'Container volume must be between 50-2000ml',
    'general_settings.calibration_stop_confirm': 'Calibration Stop Confirm',
    'general_settings.calibration_stop_confirm_desc': 'Delay before stopping an active calibration',
    'general_settings.calibration_stop_confirm_range': 'Calibration stop confirm must be between 0-5000ms',
    'general_settings.led_count': 'LED Count',
    'general_settings.led_count_desc': 'Number of LEDs used on the device',
    'general_settings.led_count_range': 'LED count must be between 1-300',
    'general_settings.manual_pour_mode': 'Manual Pour Mode',
    'general_settings.manual_pour_mode_desc': 'Choose how manual pouring behaves',
    'general_settings.manual_mode_hold': 'Hold to pour',
    'general_settings.manual_mode_toggle': 'Toggle pour',
    'general_settings.home_logo': 'Home Logo',
    'general_settings.home_logo_desc': 'Logo key shown on the home screen',
    'general_settings.home_logo_range': 'Home logo key must be 0-128 characters',
    'general_settings.pouring_completion_window': 'Pouring Completion Window',
    'general_settings.pouring_completion_window_desc': 'How long the completed pour remains open for manual top-off',
    'general_settings.pouring_completion_window_range': 'Completion window must be between 1000-10000ms',
    'general_settings.inactivity_timeout': 'Inactivity Timeout',
    'general_settings.inactivity_timeout_desc': 'Auto-return to Home after inactivity on pour flow screens',
    'general_settings.inactivity_timeout_range': 'Inactivity timeout must be between 5-3600 seconds',
    'general_settings.auto_rinse_duration': 'Automatic Rinse Duration',
    'general_settings.auto_rinse_duration_desc': 'How long automatic rinse runs',
    'general_settings.auto_rinse_duration_range': 'Automatic rinse duration must be between 1-3600 seconds',
    'general_settings.home_screensaver': 'Home Screensaver',
    'general_settings.home_screensaver_desc': 'Dim home screen to 30% after inactivity and restore on first touch',
    'general_settings.home_screensaver_timeout': 'Home Screensaver Timeout',
    'general_settings.home_screensaver_timeout_desc': 'Minutes of inactivity on home screen before dimming',
    'general_settings.home_screensaver_timeout_range': 'Home screensaver timeout must be between 1-120 minutes',
    'general_settings.remote_live_log_stream': 'Remote Live Log Stream',
    'general_settings.remote_live_log_stream_desc': 'Enable packet-based live device log streaming',
    'general_settings.remote_transport_mode': 'Remote Transport Mode',
    'general_settings.remote_transport_mode_desc': 'Choose remote support transport: TCP or HTTP polling',
    'general_settings.remote_transport_mode_tcp': 'TCP',
    'general_settings.remote_transport_mode_http': 'HTTP polling',
    'general_settings.http_polling_interval': 'HTTP Polling Interval',
    'general_settings.http_polling_interval_desc': 'Polling success-loop delay (applies in HTTP polling transport mode)',
    'general_settings.http_polling_interval_range': 'HTTP polling interval must be between 0.1 and 60 seconds',
    'general_settings.daily_auto_restart_enabled': 'Auto Restart Every 24h',
    'general_settings.daily_auto_restart_enabled_desc': 'When enabled, device restarts every 24 hours while this setting remains on',
    'general_settings.operation_mode': 'Pouring Screen Mode',
    'general_settings.operation_mode_desc': 'Select Quick Pouring (user-initiated) or Self Service (customer-facing).',
    'general_settings.operation_mode_quick_pour': 'Quick Pouring',
    'general_settings.operation_mode_self_service': 'Self Service',
    'general_settings.logging_enabled': 'Logging Enabled',
    'general_settings.logging_enabled_desc': 'Global on-device log capture and journal/livestream gating',
    'general_settings.sanitation_enabled': 'Sanitation Enforcement',
    'general_settings.sanitation_enabled_desc': 'Enable or disable sanitation enforcement (also available in Sanitation page)',
    'general_settings.setup_completed': 'Initial Setup Completed',
    'general_settings.setup_completed_desc': 'Controls whether initial setup wizard is required on next startup',
    'general_settings.live_logs_title': 'Live Device Logs',
    'general_settings.live_logs_desc': 'Streaming log lines over websocket',
    'general_settings.live_logs_empty': 'No live logs yet',
    'general_settings.live_logs_prepend_timestamp': 'Prepend timestamp',
    'general_settings.live_logs_enable_persist': 'Enable persist',
    'general_settings.live_logs_disable_persist': 'Disable persist',
    'general_settings.live_logs_clear': 'Clear logs',
    'general_settings.log_journal_title': 'Log Journal',
    'general_settings.log_journal_desc': 'Flash-safe paginated device log journal',
    'general_settings.log_journal_enable': 'Enable logging',
    'general_settings.log_journal_disable': 'Disable logging',
    'general_settings.log_journal_clear': 'Clear journal',
    'general_settings.log_journal_clear_confirm': 'Clear all journal entries?',
    'general_settings.log_journal_empty': 'No journal entries',
    'general_settings.log_journal_refresh': 'Refresh page',
    'general_settings.enabled': 'Enabled',
    'general_settings.disabled': 'Disabled',
    'general_settings.measure_title': 'Measure Volume',
    'general_settings.select_drink': 'Select a drink to pour for measurement',
    'general_settings.no_base_drinks_for_measure': 'No base drinks available for measurement. Create at least one base drink.',
    'general_settings.measuring': 'Measuring...',
    'general_settings.stop_measuring': 'Stop',
    'general_settings.pouring': 'Pouring',
    'general_settings.measure_status_pouring': 'Pouring in progress',
    'general_settings.measure_status_idle': 'Idle',
    'general_settings.measured_volume': 'Measured Volume',
    'general_settings.save_volume': 'Save Volume',
    'general_settings.retry_measurement': 'Retry',
    'general_settings.measurement_saved': 'Measurement saved successfully',
    'general_settings.measurement_error': 'Measurement failed',
    'auto_rinse.title': 'Automatic Rinse',
    'auto_rinse.enabled': 'Enable automatic rinse',
    'auto_rinse.hours': 'Scheduled hours',
    'auto_rinse.idle_threshold_sec': 'Idle threshold (minutes)',
    'auto_rinse.schedule_wait_sec': 'Max wait after schedule (seconds, 0 = no timeout)',
    'auto_rinse.duration_sec': 'Automatic Rinse Duration (seconds)',
    'auto_rinse.runtime': 'Runtime Status',
    'auto_rinse.running': 'Running',
    'auto_rinse.yes': 'Yes',
    'auto_rinse.no': 'No',
    'auto_rinse.remaining': 'Remaining',
    'auto_rinse.last_rinse': 'Time since last rinse',
    'auto_rinse.start_now': 'Start Rinse Now',
    'auto_rinse.extend_30': 'Extend +30s',
    'auto_rinse.load_error': 'Failed to load automatic rinse data',
    'auto_rinse.save_success': 'Automatic rinse settings saved',
    'auto_rinse.save_error': 'Failed to save automatic rinse settings',
    'auto_rinse.start_success': 'Automatic rinse started',
    'auto_rinse.start_error': 'Failed to start automatic rinse',
    'auto_rinse.extend_success': 'Automatic rinse extended',
    'auto_rinse.extend_error': 'Failed to extend automatic rinse',
    'auto_rinse.cancel': 'Cancel Rinse',
    'auto_rinse.cancel_success': 'Automatic rinse cancelled',
    'auto_rinse.cancel_error': 'Failed to cancel automatic rinse',
    'auto_rinse.idle_range': 'Idle threshold must be between 1 and 60 minutes',
    'auto_rinse.wait_range': 'Max wait must be between 0 and 86400 seconds',
    'auto_rinse.duration_range': 'Automatic rinse duration must be between 1 and 3600 seconds',
    'public_texts.title': 'Public Texts',
    'public_texts.description': 'Customize text shown on public screens. Empty value means firmware default.',
    'public_texts.edit': 'Edit',
    'public_texts.reset': 'Default',
    'public_texts.default_mode': '(Using firmware default)',
    'public_texts.load_error': 'Failed to load public texts',
    'public_texts.save_success': 'Public text updated',
    'public_texts.save_error': 'Failed to update public text',
    'public_texts.reset_success': 'Public text reset to default',
    'public_texts.key_1': 'Home welcome line 1',
    'public_texts.key_2': 'Home welcome line 2',
    'public_texts.key_3': 'Home start button',
    'public_texts.key_4': 'Drink selection title',
    'public_texts.key_5': 'Drink selection subtitle',
    'public_texts.key_6': 'Drink config emergency stop',
    'public_texts.key_7': 'Drink config sweetness title',
    'public_texts.key_8': 'Drink config sweetness subtitle',
    'public_texts.key_9': 'Drink config size title',
    'public_texts.key_10': 'Drink config manual mode label',
    'public_texts.key_11': 'Drink config manual subtitle (hold)',
    'public_texts.key_12': 'Drink config manual subtitle (toggle)',
    'public_texts.key_13': 'Drink config cup mode label',
    'public_texts.key_14': 'Drink config container mode label',
    'public_texts.key_15': 'Pouring modal title',
    'public_texts.key_16': 'Pouring modal subtitle',

    'bluetooth.title': 'Bluetooth Settings',
    'bluetooth.enable': 'Enable Bluetooth',
    'bluetooth.enabled': 'Enabled',
    'bluetooth.disabled': 'Disabled',
    'bluetooth.status': 'Status',
    'bluetooth.connected': 'Connected',
    'bluetooth.not_connected': 'Not Connected',
    'bluetooth.advertising': 'Advertising',
    'bluetooth.not_advertising': 'Not Advertising',
    'bluetooth.device_name': 'Bluetooth Name',
    'bluetooth.customer_key': 'Customer Key',
    'bluetooth.mac_address': 'MAC Address',
    'bluetooth.start_advertising': 'Start Advertising',
    'bluetooth.stop_advertising': 'Stop Advertising',
    'bluetooth.edit_customer_key': 'Edit Customer Key',
    'bluetooth.new_customer_key': 'New Customer Key',
    'bluetooth.device_name_updated': 'Customer key updated successfully',
    'bluetooth.advertising_started': 'Advertising started',
    'bluetooth.advertising_stopped': 'Advertising stopped',
    'bluetooth.bluetooth_enabled': 'Bluetooth enabled',
    'bluetooth.bluetooth_disabled': 'Bluetooth disabled',
    'bluetooth.error': 'Bluetooth operation failed',
    'bluetooth.name_length_error': 'Customer key must be 1-20 characters',

    'wifi.title': 'WiFi',
    'wifi.enable': 'Enable WiFi',
    'wifi.enabled': 'Enabled',
    'wifi.disabled': 'Disabled',
    'wifi.status': 'Status',
    'wifi.connected': 'Connected',
    'wifi.not_connected': 'Not Connected',
    'wifi.ssid': 'Network Name (SSID)',
    'wifi.ip_address': 'IP Address',
    'wifi.wifi_enabled': 'WiFi enabled',
    'wifi.wifi_disabled': 'WiFi disabled',
    'wifi.error': 'WiFi operation failed',
    'wifi.state': 'State',
    'wifi.state_idle': 'Idle',
    'wifi.state_connecting': 'Connecting',
    'wifi.state_connected': 'Connected',
    'wifi.state_failed': 'Failed',
    'wifi.connecting': 'Connecting...',
    'wifi.connect': 'Connect',
    'wifi.connect_to_network': 'Connect to Network',
    'wifi.password': 'Password',
    'wifi.password_optional': 'Password (empty for open network)',
    'wifi.ssid_required': 'SSID is required',
    'wifi.connect_accepted': 'Connect request accepted — waiting for device...',
    'wifi.connect_failed': 'Failed to connect to WiFi network',
    'wifi.connected_to': 'Connected to',
    'wifi.wrong_password': 'Wrong password (authentication failed)',
    'wifi.network_not_found': 'Network not found',
    'wifi.timeout': 'Connect timed out — check the device status',
    'wifi.forget': 'Forget Network',
    'wifi.forget_confirm': 'Forget this network? The device will disconnect.',
    'wifi.forgot': 'Network forgotten',
    'wifi.saved_ssid': 'Saved Network (SSID)',
    'wifi.rssi': 'Signal (RSSI)',
    'wifi.last_error': 'Last Error',
    'wifi.legacy_mode': 'This device runs older firmware — using the classic WiFi configuration (scan, SSID & password).',
    'wifi.no_networks': 'No networks found',
    'wifi.permission_denied': 'You do not have permission to manage this device\'s WiFi. Ask an administrator to grant you access.',

    'system_info.update_interval': 'Data Update Interval',
    'system_info.epoch': 'Date and Time',
    'system_info.uptime': 'Uptime',
    'system_info.free_heap': 'Free Heap',
    'system_info.ntc1': 'Thermostat 1 (Cooling Unit)',
    'system_info.ntc2': 'Thermostat 2 (Heating Unit)',
    'system_info.piezo1': 'Pressure Sensor H2O',
    'system_info.piezo2': 'Pressure Sensor CO2',
    'system_info.ice_sense': 'Ice Resistance',
    'system_info.liquid_level': 'Liquid Level',
    'system_info.liquid_high': 'High',
    'system_info.liquid_low': 'Low',
    'system_info.fan_speed': 'Fan Speed',
    'system_info.boiler_state': 'Boiler State',
    'system_info.cooling_unit': 'Cooling Unit',
    'system_info.soda_unit': 'Soda Unit',
    'system_info.cooling_unit_active_time': 'Cooling Unit Active Duration',
    'system_info.cooling_unit_inactive_time': 'Cooling Unit Inactive Duration',
    'system_info.pump_active_time': 'Pump Active Duration',
    'system_info.pump_inactive_time': 'Pump Inactive Duration',
    'system_info.boiler_active_time': 'Boiler Active Duration',
    'system_info.boiler_inactive_time': 'Boiler Inactive Duration',
    'system_info.rel_sols': 'Relay Solenoids',
    'system_info.rel_sol1_state': 'Relay Solenoid 1',
    'system_info.rel_sol2_state': 'Relay Solenoid 2',
    'system_info.rel_sol3_state': 'Relay Solenoid 3',
    'system_info.rel_sol4_state': 'Relay Solenoid 4',
    'system_info.rel_sol5_state': 'Relay Solenoid 5',
    'system_info.rel_sol6_state': 'Relay Solenoid 6',
    'system_info.rel_sol7_state': 'Relay Solenoid 7',
    'system_info.rel_sol8_state': 'Relay Solenoid 8',
    'system_info.vdet': 'VDET',
    'system_info.iprop': 'IPROP',
    'system_info.ambient_unit': 'Ambient Unit',
    'system_info.circulation_pump': 'Circulation Pump',
    'system_info.filter_filler': 'Filter Filler',
    'system_info.rtc_battery': 'RTC Battery',
    'system_info.rtc_battery_ok': 'OK',
    'system_info.rtc_battery_invalid': 'Invalid',
    'system_info.icebank_state': 'IceBank State',
    'system_info.icebank_state_idle': 'Idle',
    'system_info.icebank_state_making_ice': 'Making Ice',
    'system_info.icebank_state_fault': 'Fault',
    'system_info.icebank_state_retry_cooldown': 'Retry Cooldown',
    'system_info.icebank_state_unknown': 'Unknown',
    'system_info.shabbat_info': 'Shabbat',
    'system_info.shabbat_setting_enabled': 'Setting Enabled',
    'system_info.shabbat_active': 'Active',

    'static_traits.version': 'Version',
    'static_traits.idf_ver': 'IDF Version',
    'static_traits.cores': 'MCU Cores',
    'static_traits.model': 'MCU Model',
    'static_traits.revision': 'MCU Revision',

    'build_flags.partname': 'Part Name',
    'build_flags.soda_unit': 'Soda Unit',
    'build_flags.cooling_unit': 'Cooling Unit',
    'build_flags.ambient_unit': 'Ambient Unit',
    'build_flags.circulation_pump_unit': 'Circulation Pump Unit',
    'build_flags.heating_unit': 'Heating Unit',
    'build_flags.bluetooth': 'Bluetooth',
    'build_flags.wifi': 'Wi-Fi',
    'build_flags.rel_sols': 'Relsols',
    'build_flags.serial': 'Serial',
    'build_flags.keypad': 'Keypad',

    'logs.empty_logs': 'There are no logs to display',
    'logs.machine_logs': 'Machine Logs',
    'logs.sys_logs': 'System Logs',
    'logs.parse_failed': 'Parse failed',
    'logs.show_all': 'Show all',

    'settings.refresh': 'Refresh',
    'settings.no_updates': 'Nothing to be updated',
    'settings.restore': 'Restore Settings',
    'settings.restored': 'Restored',
    'settings.aluminium_block': 'Aluminium Block',
    'settings.ice_bank': 'Ice Bank',
    'settings.general_settings': 'General Settings',
    'settings.pump_settings': 'Soda Unit Settings',
    'settings.cooling_unit_settings': 'Cooling Unit Settings',
    'settings.fix_errors': 'Fix the errors and try again',
    'settings.must_be_numeric': 'The value must be numeric',
    'settings.program_mode': 'Machine type',
    'settings.ntc1_max_value': "Max temp'",
    'settings.ntc1_min_value': "Min temp'",
    'settings.water_value': 'Water threshold',
    'settings.ice_value': 'Ice threshold',
    'settings.icebank_max_work_time_minutes': 'IceBank max work time (minutes)',
    'settings.icebank_retry_wait_minutes': 'IceBank retry wait (minutes)',
    'settings.fan_pwm_duty': 'Fan PWM duty-cycle (%)',
    'settings.compressor_cooldown': 'Cooling unit cooldown (Seconds)',
    'settings.pump_pwm_duty': 'Pump PWM duty-cycle (%)',
    'settings.min_h2o_piezo': 'Min H2O pressure',
    'settings.min_co2_piezo': 'Min CO2 pressure',
    'settings.pump_max_time': 'Pump max work-time (Seconds)',
    'settings.piezo1_calib': 'H2O pressure sensor calibration (Milli-Volt)',
    'settings.piezo2_calib': 'CO2 pressure sensor calibration (Milli-Volt)',
    'settings.boiler_settings': 'Boiler Settings',
    'settings.boiler_max_heat': 'Max boil threshold',
    'settings.boiler_min_heat': 'Min boil threshold',
    'settings.boiler_enable': 'Activate boiler',
    'settings.wifi_enable': 'Activate wifi',
    'settings.auto_socket_connect': 'Auto socket connect',
    'settings.socket_transport_mode': 'Socket Transport Mode',
    'settings.socket_transport_mode_tcp': 'TCP Socket',
    'settings.socket_transport_mode_http_polling': 'HTTP Polling',
    'settings.http_poll_rate_ms': 'HTTP Polling Interval (ms)',
    'settings.logging_enabled': 'Logging Enabled',
    'settings.remote_live_log_stream_enabled': 'Remote Live Log Stream',
    'settings.ignore_h2o_piezo': 'Ignore H2O Pressure',
    'settings.ignore_co2_piezo': 'Ignore CO2 Pressure',
    'settings.one_liq_lev': 'Single liquid level',
    'settings.one_liq_lev_delay': 'Delay after full liquid (Seconds)',
    'settings.fan_disabled': 'Disable fan',
    'settings.liquid_level_enabled': 'Activate soda unit',
    'settings.pump_start_delay': 'Pump start delay (Seconds)',
    'settings.pump_stop_delay': 'Pump stop delay (Seconds)',
    'settings.ambient_unit_settings': 'Ambient Unit Settings',
    'settings.ambient_monitor_enabled': 'Activate ambient unit',
    'settings.ntc2_max_value': "Max temp'",
    'settings.ntc2_min_value': "Min temp'",
    'settings.fan_max_work_time': 'Fan max work-time (Seconds)',
    'settings.fan_cool_time': 'Fan cooldown (Seconds)',
    'settings.circulation_pump_settings': 'Circulation Pump Settings',
    'settings.circulation_delay_stop': 'Circulation pump stop delay (Seconds)',
    'settings.circulation_interval': 'Circulation pump interval (Seconds)',
    'settings.circulation_work_time': 'Circulation pump work-time (Seconds)',
    'settings.circulation_enabled': 'Activate circulation pump',
    'settings.cooling_unit_enabled': 'Activate cooling unit',
    'settings.one_liq_lev_indicator_is_low': 'Select liquid level indicator',
    'settings.lower_level': 'Low Sensor',
    'settings.higher_level': 'High Sensor',
    'settings.shabbat_settings': 'Shabbat Settings',
    'settings.shabbat_mode_enabled': 'Enable shabbat mode',
    'settings.shabbat_high_delay_min_ms': 'High delay min (Seconds)',
    'settings.shabbat_high_delay_max_ms': 'High delay max (Seconds)',
    'settings.shabbat_low_delay_min_ms': 'Low delay min (Seconds)',
    'settings.shabbat_low_delay_max_ms': 'Low delay max (Seconds)',
    'settings.shabbat_low_cs_sleep_add_ms': 'Low CS sleep add (Seconds)',
    'settings.shabbat_cooling_interval_minutes': 'Cooling interval (Minutes)',
    'settings.shabbat_cooling_check_minutes': 'Cooling check (Minutes)',

    'wificonfig.sta_settings': 'Station Configuration',
    'wificonfig.sta_ssid': 'Station ssid',
    'wificonfig.sta_pass': 'Station password',
    'wificonfig.sta_warning': '* The client will be disconnected upon saving.',
    'wificonfig.scan': 'Wi-Fi Scan',
    'wificonfig.connect': 'Connect',

    'datetime.sync_with_local': 'Sync with local time',

    'customerdata.name': 'Customer Name',
    'customerdata.address': 'Address',
    'customerdata.city': 'City',
    'customerdata.telephone': 'Telephone',
    'customerdata.cellphone1': 'Cellphone 1',
    'customerdata.cellphone2': 'Cellphone 2',
    'customerdata.mail': 'Email',
    'customerdata.company': 'Company',
    'customerdata.notes': 'Notes',
    'customerdata.key': 'Key',
    'customerdata.key_max_length': 'Key cannot exceed 20 characters',
    'customerdata.key_english_only': 'Key must contain only English characters',
    'customerdata.characters': 'characters',

    'system_actions.restart': 'Reboot',
    'system_actions.restart_message': 'The system will reboot in a second',
    'system_actions.test_env_enable': 'Activate Test Mode',
    'system_actions.test_env_disable': 'Stop Test Mode',
    'system_actions.fan': 'Fan',
    'system_actions.cooling_unit': 'Cooling Unit',
    'system_actions.pump': 'Pump',
    'system_actions.boiler': 'Boiler',
    'system_actions.rel_sol1': 'Relay Solenoid 1',
    'system_actions.rel_sol2': 'Relay Solenoid 2',
    'system_actions.rel_sol3': 'Relay Solenoid 3',
    'system_actions.rel_sol4': 'Relay Solenoid 4',
    'system_actions.rel_sol5': 'Relay Solenoid 5',
    'system_actions.rel_sol6': 'Relay Solenoid 6',
    'system_actions.rel_sol7': 'Relay Solenoid 7',
    'system_actions.rel_sol8': 'Relay Solenoid 8',
    'system_actions.compressor': 'Compressor',
    'system_actions.delete_logs': 'Delete logs',
    'system_actions.monitoring_enable': 'Enable monitoring',
    'system_actions.monitoring_disable': 'Disable monitoring',

    'ota.start': 'Start Update',
    'ota.start_legacy': 'Start Update (Legacy)',
    'ota.start_http': 'Start Update (HTTP)',
    'ota.stop': 'Abort Update',
    'license.title': 'License',
    'license.load_error': 'Failed to load license data',
    'license.policy_updated': 'Policy updated',
    'license.policy_update_failed': 'Failed to update policy',
    'license.license_key_required': 'License key is required',
    'license.activated': 'License activated',
    'license.activation_failed': 'Activation failed',
    'license.check_complete': 'License check complete',
    'license.check_failed': 'License check failed',
    'license.temp_unlock_granted': 'Temporary unlock granted',
    'license.temp_unlock_failed': 'Temporary unlock failed',
    'license.required': 'Required',
    'license.status': 'Status',
    'license.can_start_new_pour': 'Can Start New Pour',
    'license.ntp_synced_once': 'NTP Synced Once',
    'license.temp_unlock_used_cycle': 'Temp Unlock Used (Cycle)',
    'license.plan': 'Plan',
    'license.cycle_id': 'Cycle ID',
    'license.activation': 'Activation',
    'license.expiry': 'Expiry',
    'license.temp_unlock_until': 'Temp Unlock Until',
    'license.last_check': 'Last Check',
    'license.seconds_until_expiry': 'Seconds Until Expiry',
    'license.seconds_until_temp_unlock_end': 'Seconds Until Temp Unlock End',
    'license.message': 'Message',
    'license.refresh': 'Refresh',
    'license.activation_section': 'Activation',
    'license.license_key': 'License Key',
    'license.activate': 'Activate',
    'license.check_now': 'Check Now',
    'license.temp_unlock_section': 'Temporary Unlock',
    'license.requested_seconds': 'Requested Hours',
    'license.request_temp_unlock': 'Request Temp Unlock',
    'license.policy_section': 'Policy',
    'license.license_required': 'License Required',
    'license.trial_days': 'Trial Days',
    'license.default_temp_unlock_sec': 'Default Temp Unlock (hours)',
    'license.yes': 'Yes',
    'license.no': 'No',
    'license.status_not_required': 'Not Required',
    'license.status_waiting_ntp': 'Waiting for NTP',
    'license.status_trial': 'Trial',
    'license.status_active': 'Active',
    'license.status_temp_unlock': 'Temp Unlock',
    'license.status_expired': 'Expired',
    'license.status_revoked': 'Revoked',
    'license.status_none': 'No License',
    'sanitation.title': 'Sanitation',
    'sanitation.load_error': 'Failed to load sanitation data',
    'sanitation.status': 'Status',
    'sanitation.status_waiting_for_sync': 'Waiting for Sync',
    'sanitation.status_compliant': 'Compliant',
    'sanitation.status_due_soon': 'Due Soon',
    'sanitation.status_overdue': 'Overdue',
    'sanitation.status_disabled': 'Disabled',
    'sanitation.enabled': 'Enabled',
    'sanitation.can_start_new_pour': 'Can Start New Pour',
    'sanitation.ntp_synced_once': 'NTP Synced Once',
    'sanitation.interval_days': 'Interval (days)',
    'sanitation.warning_days': 'Warning window (days)',
    'sanitation.seconds_until_due': 'Seconds Until Due',
    'sanitation.last_completed': 'Last Completed',
    'sanitation.next_due': 'Next Due',
    'sanitation.last_check': 'Last Check',
    'sanitation.message': 'Message',
    'sanitation.check_now': 'Check Now',
    'sanitation.check_success': 'Sanitation check completed',
    'sanitation.check_error': 'Sanitation check failed',
    'sanitation.complete_now': 'Complete Sanitation',
    'sanitation.complete_success': 'Sanitation completed',
    'sanitation.complete_error': 'Sanitation completion failed',
    'sanitation.policy': 'Policy',
    'sanitation.policy_saved': 'Sanitation policy saved',
    'sanitation.policy_error': 'Sanitation policy update failed',
    'sanitation.interval_hint': 'Valid range: 30-3650 days.',
    'sanitation.interval_range': 'Interval must be between 30 and 3650 days',
    'ota.select_software': 'Select Version',
    'ota.start_err_already_patching': 'The machine is already being patched',
    'ota.start_err_not_in_sync': 'The server is not synchronized with the machine, initiate a restart',
    'ota.success_message': 'The update finished successfully, the machine will now restart',
    'ota.write_err_already_active': 'The device is already patching',
    'ota.write_err_begin_failed': 'Failed to start update',
    'ota.write_err_current_running_version_same_as_new': 'Current running version is the same as a new',
    'ota.write_err_new_version_same_as_invalid_version': 'New version is the same as invalid version',
    'ota.write_err_received_package_not_fit_len': 'Received package is not fit length',
    'ota.write_err_write_failed': 'Failed to write to the device, trying again',
    'ota.bin_model_mismatch': 'The MCU model ({0}) does not match the bin chip ID ({1})',
    'ota.c6_subtitle': 'ESP32-C6 WiFi/BT coprocessor (network_adapter) firmware. Push the image over the socket, or let the machine download it over HTTP.',
    'ota.c6_select_software': 'Select WiFi Module Version',
    'ota.c6_no_versions': 'No C6 firmware has been published for this machine model yet',
    'ota.c6_update_http': 'Update WiFi Module (HTTP)',
    'ota.c6_update_push': 'Update WiFi Module (Push)',
    'ota.c6_updating': 'Updating the WiFi module...',
    'ota.c6_completed': 'The WiFi module was updated successfully. The machine will now restart and reconnect shortly.',

    'files_error.invalid_file_type': 'Invalid file type',
    'files_error.too_large': 'The file is too large',
    'files_error.too_small': 'The file is too small',
    'files_error.maximum_file_count_reached': 'Maximum file count reached',

    'esp_bin_input.dnd_message': 'Drag and drop your BIN file anywhere',
    'esp_bin_input.invalid_message': 'Invalid BIN file',
    'esp_bin_input.unsupported_model_message': "The BIN isn't for the {0} model",
    'esp_bin_input.compiled_at': 'Compiled at {0} {1}',
    'esp_bin_input.app_elf_sha256': 'Sha256 of Elf file',

    'datacenter.search_query': 'Machine search query',
    'datacenter.received_logs': 'Received logs',

    'machine.machine_data': 'Machine Data',
    'machine.logs': 'Logs',

    'software_manager.no_software_versions': 'Upload your first software version by pressing the plus button',
    'software_manager.version': 'Software Version',
    'software_manager.model': 'Device Model',
    'software_manager.component': 'Firmware Component',
    'software_manager.component_app': 'Application Firmware',
    'software_manager.component_c6': 'WiFi Module (C6)',
    'software_manager.change_log': 'Change Log',
    'software_manager.uploaded_by': 'Uploaded by',
    'software_manager.created_at_format': "'Uploaded at' dd.MM.yyyy HH:mm",
    'mobile_apps.title': 'Mobile App Distribution',
    'mobile_apps.desc': 'Upload Android APK and iOS Ad Hoc IPA builds, then copy direct install links in one place.',
    'mobile_apps.android_title': 'Android APK',
    'mobile_apps.android_desc': 'Upload a signed APK and share the direct download URL.',
    'mobile_apps.ios_title': 'iOS Ad Hoc (IPA)',
    'mobile_apps.ios_desc': 'Upload an IPA and get an itms-services install link with generated plist manifest.',
    'mobile_apps.drop_apk': 'Drop APK here or click to select',
    'mobile_apps.drop_ipa': 'Drop IPA here or click to select',
    'mobile_apps.app_title_placeholder': 'App title (optional)',
    'mobile_apps.version_placeholder': 'Version (optional)',
    'mobile_apps.notes_placeholder': 'Release notes (optional)',
    'mobile_apps.ios_title_placeholder': 'App title (optional)',
    'mobile_apps.bundle_placeholder': 'Bundle identifier (e.g. com.company.app)',
    'mobile_apps.upload_apk': 'Upload APK',
    'mobile_apps.upload_ipa': 'Upload IPA',
    'mobile_apps.releases': 'Uploaded Releases',
    'mobile_apps.empty': 'No uploads yet.',
    'mobile_apps.download': 'Download',
    'mobile_apps.copy_link': 'Copy Link',
    'mobile_apps.install_ios': 'Install iOS',
    'mobile_apps.copy_install_link': 'Copy Install Link',
    'mobile_apps.edit_title': 'Edit Title',
    'mobile_apps.title_updated': 'Title updated',
    'mobile_apps.title_update_failed': 'Failed to update title',
    'mobile_apps.title_required': 'Title is required',
    'mobile_apps.delete_confirm': 'Delete this uploaded app?',
    'mobile_apps.copied': 'Link copied',
    'mobile_apps.copy_failed': 'Failed to copy link',
    'mobile_apps.load_failed': 'Failed to load uploaded apps',
    'mobile_apps.upload_success': 'Upload completed',
    'mobile_apps.upload_failed': 'Upload failed',
    'mobile_apps.pick_apk_first': 'Select an APK file first',
    'mobile_apps.pick_ipa_first': 'Select an IPA file first',
    'mobile_apps.delete_failed': 'Failed to delete uploaded app',

    'usb_flash_artifacts.title': 'USB Flash Artifacts',
    'usb_flash_artifacts.desc': 'Upload USB flash manifests and BIN files for mobile USB flasher.',
    'usb_flash_artifacts.upload_title': 'Upload New Artifact',
    'usb_flash_artifacts.manifest_json': 'Manifest JSON',
    'usb_flash_artifacts.parse_manifest': 'Parse Manifest',
    'usb_flash_artifacts.parse_manifest_first': 'Parse the manifest first',
    'usb_flash_artifacts.pick_manifest_first': 'Select manifest JSON first',
    'usb_flash_artifacts.manifest_parsed': 'Manifest parsed successfully',
    'usb_flash_artifacts.manifest_parse_failed': 'Manifest parse failed',
    'usb_flash_artifacts.id_placeholder': 'Manifest ID (optional)',
    'usb_flash_artifacts.title_placeholder': 'Title (optional)',
    'usb_flash_artifacts.chip_placeholder': 'Chip (esp32p4 / esp32s3 / esp32c6)',
    'usb_flash_artifacts.model_placeholder': 'Model',
    'usb_flash_artifacts.version_placeholder': 'Version (optional)',
    'usb_flash_artifacts.pick_model': 'Select a model before upload',
    'usb_flash_artifacts.chip_auto': 'Chip (auto from model)',
    'usb_flash_artifacts.overwrite': 'Overwrite existing manifest ID',
    'usb_flash_artifacts.segments': 'Manifest Segment Files',
    'usb_flash_artifacts.upload_button': 'Upload Artifact',
    'usb_flash_artifacts.upload_success': 'Artifact uploaded',
    'usb_flash_artifacts.upload_failed': 'Artifact upload failed',
    'usb_flash_artifacts.load_failed': 'Failed to load USB flash manifests',
    'usb_flash_artifacts.existing': 'Existing Manifests',
    'usb_flash_artifacts.empty': 'No USB flash manifests found',
    'usb_flash_artifacts.missing_segment': 'Missing BIN file for path: {0}',
    'usb_flash_artifacts.filter_title_placeholder': 'Filter by model/title',
    'usb_flash_artifacts.filter_model_all': 'All models',
    'usb_flash_artifacts.delete_confirm': 'Delete manifest "{0}"?',
    'usb_flash_artifacts.delete_success': 'Manifest deleted',
    'usb_flash_artifacts.delete_failed': 'Failed to delete manifest',

    'client_model.standard': 'Standard (0x0001)',
    'client_model.lti525s': 'LTI525S (0x0002)',
    'client_model.syrup_tower': 'Syrup Tower (0x0003)',
    'client_model.filter_filler': 'Filter Filler (0x0004)',
    'client_model.ltsp101': 'LTSP101 (0x0005)',
    'client_model.ltcb220': 'LTCB220 (0x0006)',
    'client_model.ltsp70': 'LTSP70 (0x0007)',
    'client_model.ltsp175': 'LTSP175 (0x0008)',
    'client_model.ltcb226': 'LTCB226 (0x0009)',

    'window.confirm': 'Confirm',
    'window.decline': 'Cancel',

    'flash_device.begin_flash': 'Begin Flash',
    'flash_device.flashing': 'Flashing...',
    'flash_device.flash_complete': 'Flash Complete',
    'flash_device.flash_failed': 'Failed to flash device',

    'memory.kb': 'KB',
    'memory.mb': 'MB',
    'memory.gb': 'GB',
} as ILocaleStrings
